import { apiClient } from "./httpClient";
import { unwrapEnvelope } from "./response";

export const subscriptionApi = {
  async getSubscription() {
    const response = await apiClient.get("/subscription");
    return unwrapEnvelope(response.data, {});
  },

  async getSubscriptionStatus() {
    const response = await apiClient.get("/subscription/status");
    return unwrapEnvelope(response.data, {});
  },

  async createSubscription(plan) {
    const response = await apiClient.post("/subscription/create", { plan });
    return unwrapEnvelope(response.data, {});
  },

  async changePlan(plan) {
    const response = await apiClient.post("/subscription/change-plan", { plan });
    return unwrapEnvelope(response.data, {});
  },

  async cancelSubscription() {
    const response = await apiClient.post("/subscription/cancel", {});
    return unwrapEnvelope(response.data, {});
  }
};
